import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./BookingForm.module.css";
// import logo from "../../components/logo.svg";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { Col, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  GET_USER_BY_EMAIL_OR_PHONE,
  CANCEL_SURVEY_BOOKING,
  GET_SURVEY_BOOKINGS_BY_EMAIL,
  BOOKINGS_API_URL,
  AVAILABLE_SLOTS,
} from "../../api/apiPath.js";
import http from "../../api/server";
import Toaster from "../common/Toaster";
import Header from "../common/Header.js";
// import ConfirmationPopup from "../common/ConfirmationPopup";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/London");

const BookingForm = () => {
  const navigate = useNavigate();
  const { userObj } = useSelector((s) => s.user);
  const token = localStorage.getItem("authToken");
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [activeTab, setActiveTab] = useState("New Booking");
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    primaryEmail: "",
    alternateEmail: "",
    mobileNumber: "",
    mobileCountryCode: "gb",
    landlineNumber: "",
    propertyAddress: "",
    apartmentNumber: "",
    buildingName: "",
    blockName: "",
    address: "",
    cityName: "",
    postCode: "",
    numberOfDoors: "",
    appointmentDate: dayjs().tz("Europe/London"),
    appointmentTime: "",
    specialRequest: "",
    bookedInspectorEmail: "",
    postCodeInfo: "",
    bookingTrackingRefNumber: "" 
  });
  const [alreadyBookByAnother, setAlreadyBookByAnother] = useState(false);
  const [alreadyBookBySameUser, setAlreadyBookBySameUser] = useState(false);
  // const [showCancelBookingButton, setShowCancelBookingButton] = useState(false);
  const [wantToUpdate, setWantToUpdate] = useState(false);
  const [myBookingData, setMyBookingData] = useState({});
  const [myBookingList, setMyBookingList] = useState([]);
  const [myPastBookingList, setMyPastBookingList] = useState([]);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [errors, setErrors] = useState({});
  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const BOOKINGS_API_URL =
  //   //"https://psl-dev-webapp-uksouth-ecb4bcaabsd9gufn.uksouth-01.azurewebsites.net/api/SurveyBooking";
  //   "https://localhost:5001/api/SurveyBooking";

  //Clientid needs to be dynamic
  const clientId = "E54D74F7-3367-4286-87AC-DD70C94B7B3E";

  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedInspector, setSelectedInspector] = useState("");
  const [showNoAvailableSlotsMessage, setShowNoAvailableSlotsMessage] =
    useState(false);
  const [showTime, setShowTime] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const [isLoading, setIsLoading] = useState(true);
  // When GetUserByEmailOrPhone returns scheduleDTO with slotsByDay, calendar/slots use this range
  const [userScheduleDTO, setUserScheduleDTO] = useState(null);

  useEffect(() => {
    if (!userObj && !token) {
      navigate("/", { replace: true, state: { from: "/booking" } });
    }
  }, [userObj, token, navigate]);

  useEffect(() => {
    const fetchBookingByEmail = async () => {
      try {
        const email = userObj?.userEmail;
        if (!email) return;
        // Call GET API with email as query param
        const responseBooking = await http.get(
          GET_USER_BY_EMAIL_OR_PHONE + email
        );
        if (!responseBooking.status) {
          throw new Error(`HTTP error! status: ${responseBooking?.status}`);
        }

        const booking = await responseBooking.data;
        if (booking) {
          setFormData({
            propertyMasterId: booking.propertyMasterId || "",
            buildingId: booking.buildingId || "",
            firstName: booking.firstName || "",
            middleName: booking.middleName || "",
            lastName: booking.lastName || "",
            primaryEmail: booking.email || "",
            alternateEmail: booking.alternateEmail || "",
            mobileNumber: booking.phoneNumber || "",
            mobileCountryCode: booking.mobileCountryCode || "gb",
            landlineNumber: booking.alternateContactNumber || "",
            propertyAddress: booking.propertyAddress || "",
            apartmentNumber: booking.apartmentOrHouseNo || "",
            buildingName: booking.propertyName || "",
            blockName: booking.buildingName || "",
            address: booking.secondaryAddress || "",
            cityName: booking.city || "",
            postCode: booking.postCode || "",
            bookingTrackingRefNumber: booking.bookingTrackingRefNumber || "",
            // numberOfDoors: booking.numberOfDoors?.toString() || "",
            // appointmentDate: booking.bookedDate ? dayjs(booking.bookedDate) : dayjs().tz("Europe/London"),
            // appointmentTime: "",
            // specialRequest: booking.specialRequest || "",
            // bookedInspectorEmail: booking.bookedInspectorEmail || "",
            // postCodeInfo: "",
            // surveyBookingId: booking.surveyBookingId || "",
          });
          // setShowTime(true);
          //  handleDateChange(
          //   booking.bookedDate ? dayjs(booking.bookedDate) : null
          // );
          if (booking.postCode) {
            fetchPostCodeInfo(booking.postCode);
          }
          setMyBookingData(booking);
          //setWantToUpdate(true);
          fetchPostCodeInfo(booking.postCode);
          console.log("useeffect");

          // Use scheduleDTO to restrict calendar and derive slots when present
          const schedule = booking.scheduleDTO;
          if (schedule?.slotsByDay != null && schedule?.slotsByDay !== "") {
            try {
              const parsed =
                typeof schedule.slotsByDay === "string"
                  ? JSON.parse(schedule.slotsByDay)
                  : schedule.slotsByDay;
              if (Array.isArray(parsed) && parsed.length > 0 && schedule.startDate && schedule.endDate) {
                const dto = {
                  startDate: schedule.startDate,
                  endDate: schedule.endDate,
                  startTime: schedule.startTime,
                  endTime: schedule.endTime,
                  slotsByDay: parsed,
                };
                setUserScheduleDTO(dto);
                const today = dayjs().tz("Europe/London");
                const start = dayjs(dto.startDate).tz("Europe/London");
                const end = dayjs(dto.endDate).tz("Europe/London");
                // Clamp initial date to schedule range for calendar display
                let initialDate = today;
                if (today.isBefore(start, "day")) initialDate = start;
                else if (today.isAfter(end, "day")) initialDate = end;
                setFormData((prev) => ({ ...prev, appointmentDate: initialDate }));
                const initialSlots = getSlotsFromScheduleDTO(initialDate, dto);
                if (initialSlots.length === 0) {
                  setAvailableSlots([]);
                  setShowNoAvailableSlotsMessage(true);
                } else {
                  setShowNoAvailableSlotsMessage(false);
                  setAvailableSlots(initialSlots);
                }
              }
            } catch (_) {
              setUserScheduleDTO(null);
            }
          } else {
            setUserScheduleDTO(null);
          }
        }
      } catch (error) {
        // handle error if needed
      }
    };

    fetchBookingByEmail();
    getMyBookings();
    
    // const today = dayjs().tz("Europe/London");
    // fetchSlots(clientId, today, 5);
  }, [userObj]);

  // async function createBookingAppointment(formData) {

  //   try {
  //     const response = await http.post(BOOKINGS_API_URL, formData);
  //     const result = await response.data;
  //     if (result.exists) {
  //       if (result.booking) {
  //         if (result.updated) {
  //           setAlreadyBookBySameUser(false);
  //           setShowConfirmation(true);
  //           setWantToUpdate(false);
  //         } else {
  //           setAlreadyBookBySameUser(true);
  //           setMyBookingData(result.booking);
  //         }
  //       } else {
  //         if (result.updated) {
  //           setShowConfirmation(true);
  //           setWantToUpdate(false);
  //         } else {
  //           setAlreadyBookByAnother(true);
  //           setWantToUpdate(false);
  //         }
  //       }
  //     } else {
  //       setShowConfirmation(true);
  //     }
  //     setErrors({});
  //   } catch (error) {
  //     return error;
  //   }
  //   // try {
  //   //   const response = await fetch(BOOKINGS_API_URL, {
  //   //     method: "POST",
  //   //     headers: { "Content-Type": "application/json" },
  //   //     body: JSON.stringify(formData),
  //   //   });
  //   //   if (!response.ok) throw new Error("Failed to create appointment");
  //   //   const result = await response.json();
  //   //   if (result.exists) {
  //   //     if (result.booking) {
  //   //       if (result.updated) {
  //   //         setAlreadyBookBySameUser(false);
  //   //         setShowConfirmation(true);
  //   //         setWantToUpdate(false);
  //   //       } else {
  //   //         setAlreadyBookBySameUser(true);
  //   //         setMyBookingData(result.booking);
  //   //       }
  //   //     } else {
  //   //       if (result.updated) {
  //   //         setShowConfirmation(true);
  //   //         setWantToUpdate(false);
  //   //       } else {
  //   //         setAlreadyBookByAnother(true);
  //   //         setWantToUpdate(false);
  //   //       }
  //   //     }
  //   //   } else {
  //   //     setShowConfirmation(true);
  //   //   }
  //   //   setErrors({});
  //   // } catch (error) {
  //   //   alert("There was an error submitting your booking. Please try again.");
  //   // }
  // }


  async function createBookingAppointment(formData) {
  try {
    const response = await http.post(BOOKINGS_API_URL, formData);
    const result = response.data;

    if (result?.success === false) {
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString:
          result?.message ||
          "No available inspector found for the selected date.",
      });
      return;
    }

    if (result.exists) {
      if (result.booking) {
        if (result.updated) {
          setAlreadyBookBySameUser(false);
          setShowConfirmation(true);
          setWantToUpdate(false);
        } else {
          setAlreadyBookBySameUser(true);
          setMyBookingData(result.booking);
        }
      } else {
        if (result.updated) {
          setShowConfirmation(true);
          setWantToUpdate(false);
        } else {
          setAlreadyBookByAnother(true);
          setWantToUpdate(false);
        }
      }
    } else {
      setShowConfirmation(true);
    }

    setErrors({});
  } catch (error) {

    setToastData({
      toastShow: true,
      toastType: "failure",
      toastString:
        error?.response?.data?.message ||
        "No available inspector found for the selected date.",
    });

    return error;
  }
}

  // Build time slots from scheduleDTO.slotsByDay for a given date (same shape as API slots)


  const getSlotsFromScheduleDTO = (selectedDate, schedule) => {
    if (!schedule?.slotsByDay?.length || !selectedDate) return [];
    // Use Europe/London so date string matches slotsByDay (avoids off-by-one when switching dates)
    const dateStr = dayjs(selectedDate).tz("Europe/London").format("YYYY-MM-DD");
    const daySlot = schedule.slotsByDay.find((d) => d.date === dateStr);
    if (!daySlot?.startTime || !daySlot?.endTime) return [];
    const startParts = daySlot.startTime.split(":");
    const endParts = daySlot.endTime.split(":");
    const startH = parseInt(startParts[0], 10) || 0;
    const startM = parseInt(startParts[1], 10) || 0;
    const endH = parseInt(endParts[0], 10) || 0;
    const endM = parseInt(endParts[1], 10) || 0;
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;
    const intervalMinutes = 30;
    const slots = [];
    for (let m = startMinutes; m < endMinutes; m += intervalMinutes) {
      const h = Math.floor(m / 60);
      const min = m % 60;
      const timeStr = `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}:00`;
      const dateTimeStr = `${dateStr}T${timeStr}`;
      const ukTime = dayjs.tz(dateTimeStr, "Europe/London");
      slots.push({
        startTimeFormat: ukTime.format("hh:mm A"),
        startDateOnly: dateStr,
        formattedDateTime: ukTime.format("YYYY-MM-DDTHH:mm"),
        startTime: ukTime.format("YYYY-MM-DDTHH:mm:ss"),
        ukTimeObj: ukTime,
        availableInspectors: [],
      });
    }
    const now = dayjs().tz("Europe/London");
    return slots.filter((slot) => slot.ukTimeObj.isAfter(now));
  };

  const fetchSlots = async (clientId, date, noOfDoors) => {
    try {
      // if(noOfDoors === "" || noOfDoors === undefined){
      //     errors.appointmentTime = "Please enter number of doors to get slot timings.";
      //      setAvailableSlots([]);
      //       setShowNoAvailableSlotsMessage(false);
      //     return;
      // }else if(parseInt(noOfDoors) <= 0){
      //     errors.appointmentTime = "Number of doors must be greater than zero.";
      //      setAvailableSlots([]);
      //       setShowNoAvailableSlotsMessage(false);
      //     return;
      // }else{
      //   errors.appointmentTime = "";
      // }

      const queryParams = new URLSearchParams({
        date: date,
        numberOfDoors: noOfDoors != undefined ? noOfDoors?.toString() : 0,
        clientId,
        surveyBookingId: myBookingData?.surveyBookingId
      });
      const response = await http.get(AVAILABLE_SLOTS + queryParams);
      // await fetch(
      //   //`https://psl-dev-webapp-uksouth-ecb4bcaabsd9gufn.uksouth-01.azurewebsites.net/api/SurveyBooking/available-slots?${queryParams}`
      //   `${AVAILABLE_SLOTS}${queryParams}`
      // );
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }

      const data = await response?.data;
      const formatted = data.map((slot) => {
        const ukTime = dayjs.tz(slot.startTime, "Europe/London");
        return {
          ...slot,
          startTimeFormat: ukTime.format("hh:mm A"),
          startDateOnly: ukTime.format("YYYY-MM-DD"),
          formattedDateTime: ukTime.format("YYYY-MM-DDTHH:mm"),
          startTime: ukTime.format("YYYY-MM-DDTHH:mm:ss"),
          ukTimeObj: ukTime,
        };
      });
      const now = dayjs();
      const futureSlots = formatted.filter((slot) =>
        slot.ukTimeObj.isAfter(now)
      );
      if (futureSlots.length === 0) {
        setAvailableSlots([]);
        setShowNoAvailableSlotsMessage(true);
      } else {
        setShowNoAvailableSlotsMessage(false);
        setAvailableSlots(futureSlots);
      }
      return futureSlots;
    } catch (error) {
      // handle error
    }
  };

  useEffect(() => {
    const today = dayjs().tz("Europe/London");
    fetchSlots(clientId, today, formData.numberOfDoors);
  }, []);


  const fetchPostCodeInfo = async (postcode) => {
    if (!postcode) return;
    try {
      const res = await fetch(`https://api.postcodes.io/postcodes/${postcode}`);
      const data = await res.json();
      if (data.status === 200) {
        setFormData((formData) => ({
          ...formData,
          postCodeInfo:
            (data.result.ced ? data.result.ced + ", " : "") +
            (data.result.pfa ? data.result.pfa + ", " : "") +
            data.result.country,
        }));
        setErrors((prev) => ({ ...prev, postCode: "" }));
      } else {
        setFormData((formData) => ({
          ...formData,
          postCodeInfo: "",
        }));
        setErrors((prev) => ({ ...prev, postCode: "Invalid UK Post Code" }));
      }
    } catch {
      setFormData((formData) => ({
        ...formData,
        postCodeInfo: "",
      }));
      setErrors((prev) => ({
        ...prev,
        postCode: "Failed to fetch postcode details",
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "postCode") {
      formattedValue = value.toUpperCase().replace(/\s+/g, "");
      if (formattedValue.length > 5) {
        formattedValue =
          formattedValue.slice(0, -3) + " " + formattedValue.slice(-3);
      }
    }
    setFormData({ ...formData, [name]: formattedValue });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const resetform = () => {
    setFormData((prev) => ({
      ...prev,
      address: "",
      numberOfDoors: "",
      appointmentDate: dayjs().tz("Europe/London"),
      appointmentTime: "",
      specialRequest: "",
      bookedInspectorEmail: "",
    }));
    setShowConfirmation(false);
    setShowTime(false);
    const today = dayjs().tz("Europe/London");
    if (userScheduleDTO) {
      const slots = getSlotsFromScheduleDTO(today, userScheduleDTO);
      if (slots.length === 0) {
        setAvailableSlots([]);
        setShowNoAvailableSlotsMessage(true);
      } else {
        setShowNoAvailableSlotsMessage(false);
        setAvailableSlots(slots);
      }
    } else {
      fetchSlots(clientId, today, formData.numberOfDoors);
    }
    setAlreadyBookBySameUser(false);
    setAlreadyBookByAnother(false);
  };

  const handleDateChange = (date) => {
    const normalizedDate = date ? dayjs(date).tz("Europe/London") : date;
    setFormData((prev) => ({
      ...prev,
      appointmentDate: normalizedDate,
    }));
    if (userScheduleDTO) {
      const slots = getSlotsFromScheduleDTO(normalizedDate, userScheduleDTO);
      if (slots.length === 0) {
        setAvailableSlots([]);
        setShowNoAvailableSlotsMessage(true);
      } else {
        setShowNoAvailableSlotsMessage(false);
        setAvailableSlots(slots);
      }
      return;
    }
    const selectedDate = date?.tz("Europe/London").format("YYYY-MM-DD");
    let numberOfDoors = 0;
    if (formData.numberOfDoors === "" || formData.numberOfDoors === undefined) {
      numberOfDoors = myBookingData.numberOfDoors;
    } else {
      numberOfDoors = formData.numberOfDoors;
    }
    fetchSlots(clientId, selectedDate, numberOfDoors);
  };

  const handleTimeSelectupdate = (date) => {
    var availableInspectors =
      availableSlots.find(
        (slot) => slot.formattedDateTime === date?.format("YYYY-MM-DDTHH:mm")
      )?.availableInspectors || [];
    setSelectedInspector(availableInspectors[0] || "");
    console.log(selectedInspector);
    setShowTime(true);
    setFormData((prev) => ({
      ...prev,
      appointmentDate: date,
    }));
    setFormData((prev) => ({
      ...prev,
      bookedInspectorEmail: availableInspectors[0],
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      appointmentDate: undefined,
      appointmentTime:undefined
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    if (!formData.primaryEmail)
      newErrors.primaryEmail = "Email Address is required";
    if (!formData.mobileNumber) {
      newErrors.mobileNumber = "Mobile Number is required";
    }
    if (!formData.propertyAddress)
      newErrors.propertyAddress = "Site Address is required";
    if (!formData.apartmentNumber)
      newErrors.apartmentNumber = "Apartment/Flat/House No is required";
    if (!formData.buildingName)
      newErrors.buildingName = "Site Name is required";
    if (!formData.blockName)
      newErrors.blockName = "Building Name is required";
    if (!formData.cityName) newErrors.cityName = "City is required";
    if (!formData.postCode) {
      newErrors.postCode = "Post Code is required";
    } else if (!ukPostcodeRegex.test(formData.postCode.trim())) {
      newErrors.postCode = "Invalid UK Post Code";
    }
    if (!formData.numberOfDoors) {
      newErrors.numberOfDoors = "Number of Doors is required";
    } else if (
      isNaN(Number(formData.numberOfDoors)) ||
      Number(formData.numberOfDoors) < 0
    ) {
      newErrors.numberOfDoors = "Number of Doors cannot be negative";
    }
    if (!formData.appointmentDate)
      newErrors.appointmentDate = "Appointment Date is required";
    if (!showTime) newErrors.appointmentTime = "Appointment Time is required";
    return newErrors;
  };

  const getMyBookings = async () => {
    try {
      console.log("getbooking")
      setIsLoading(true);
      setMyBookingData({});
        setMyBookingList([]);
      const email = userObj?.userEmail;
      if (!email) return;
      // Call GET API with email as query param
      const responseBooking = await http.get(
        GET_SURVEY_BOOKINGS_BY_EMAIL + email
      );
      if (!responseBooking.status) {
        throw new Error(`HTTP error! status: ${responseBooking?.status}`);
      }

      const booking = await responseBooking.data.futureBookings;
      if (booking.length > 0) {
        setMyBookingData(booking[0]);
        setMyBookingList([...booking]);
        
      }

      const pastBooking = await responseBooking.data.pastBookings;
      if (pastBooking.length > 0) {
        setMyPastBookingList(pastBooking);
      }
      setIsLoading(false);
    } catch (error) {
      // handle error if needed
    }
  };


  const bindBookingData = () => {
    setShowTime(true);
    setAlreadyBookBySameUser(false);
    setWantToUpdate(true);
    setFormData({
      firstName: myBookingData.firstName || "",
      middleName: myBookingData.middleName || "",
      lastName: myBookingData.lastName || "",
      primaryEmail: myBookingData.primaryEmailAddress || "",
      alternateEmail: myBookingData.alternateEmailAddress || "",
      mobileNumber: myBookingData.mobileNumber || "",
      mobileCountryCode: myBookingData.mobileCountryCode || "gb",
      landlineNumber: myBookingData.landlineNumber || "",
      propertyAddress: myBookingData.address || "",
      apartmentNumber: myBookingData.apartmentNumber || "",
      buildingName: myBookingData.buildingName || "",
      address: myBookingData.secondaryAddress || "",
      cityName: myBookingData.city || "",
      postCode: myBookingData.postCode || "",
      numberOfDoors: myBookingData.numberOfDoors?.toString() || "0",
      appointmentDate: myBookingData.bookedDate
        ? dayjs(myBookingData.bookedDate)
        : null,
      appointmentTime: "",
      specialRequest: myBookingData.specialRequest || "",
      bookedInspectorEmail: myBookingData.bookedInspectorEmail || "",
      bookingTrackingRefNumber: myBookingData.bookingTrackingRefNumber || "",
      postCodeInfo: "",
    });
    handleDateChange(
      myBookingData.bookedDate ? dayjs(myBookingData.bookedDate) : null
    );
    if (myBookingData.postCode) {
      fetchPostCodeInfo(myBookingData.postCode);
    }
  };

const firstNameRef = useRef(null);
const lastNameRef = useRef(null);
const emailRef = useRef(null);
const mobileRef = useRef(null);
const propertyNameRef = useRef(null);
const propertyAddressRef = useRef(null);
const apartmentRef = useRef(null);
const cityRef = useRef(null);
const postCodeRef = useRef(null);
const doorsRef = useRef(null);
const calendarRef = useRef(null);
const timeRef = useRef(null);
const blockNameRef = useRef(null)

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    // if (Object.keys(validationErrors).length > 0) {
    //   setErrors(validationErrors);
    // } 
     if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    const fieldOrder = [
      { key: "firstName", ref: firstNameRef },
      { key: "lastName", ref: lastNameRef },
      { key: "primaryEmail", ref: emailRef },
      { key: "mobileNumber", ref: mobileRef },
      { key: "buildingName", ref: propertyNameRef },
      { key: "blockName", ref: blockNameRef },
      { key: "propertyAddress", ref: propertyAddressRef },
      { key: "apartmentNumber", ref: apartmentRef },
      { key: "cityName", ref: cityRef },
      { key: "postCode", ref: postCodeRef },
      { key: "numberOfDoors", ref: doorsRef },
      { key: "appointmentDate", ref: calendarRef },
      { key: "appointmentTime", ref: timeRef },
    ];

    const firstErrorField = fieldOrder.find(
      (field) => validationErrors[field.key]
    );

    if (firstErrorField?.ref?.current) {
      firstErrorField.ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      if (firstErrorField.ref.current.focus) {
        firstErrorField.ref.current.focus();
      }
    }

    return;
  }

    
    
    else {
      setIsSubmitting(true);
      try {
        const payload = {
          propertyMasterId: formData.propertyMasterId,
          buildingId: formData.buildingId,
          firstName: formData.firstName,
          middleName: formData.middleName,
          lastName: formData.lastName,
          primaryEmailAddress: formData.primaryEmail,
          alternateEmailAddress: formData.alternateEmail,
          mobileNumber: formData.mobileNumber,
          mobileCountryCode: formData.mobileCountryCode,
          landlineNumber: formData.landlineNumber,
          apartmentNumber: formData.apartmentNumber,
          buildingName: formData.buildingName,
          address: formData.propertyAddress,
          city: formData.cityName,
          postCode: formData.postCode,
          numberOfDoors: parseInt(formData.numberOfDoors),
          specialRequest: formData.specialRequest || "",
          bookedInspectorEmail: formData.bookedInspectorEmail || "",
          bookedDate: formData.appointmentDate
            ? formData.appointmentDate.format("YYYY-MM-DDTHH:mm:ss")
            : "",
          startTime: formData.appointmentDate
            ? formData.appointmentDate.format("YYYY-MM-DDTHH:mm:ss")
            : "",
          endTime: formData.appointmentDate
            ? formData.appointmentDate
                .add(3, "hour")
                .format("YYYY-MM-DDTHH:mm:ss")
            : dayjs().add(3, "hour").format("YYYY-MM-DDTHH:mm:ss"),
          isUpdated: wantToUpdate ? true : false,
          secondaryAddress: formData.address,
          SurveyBookingId: myBookingData?.surveyBookingId ?? "",
          bookingTrackingRefNumber: formData.bookingTrackingRefNumber,
          Status: "",
        };
        await createBookingAppointment(payload);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  async function cancelBooking() {
    const payload = {
      surveyBookingId: myBookingList[0].surveyBookingId,
      modifiedByUserEmail: myBookingList[0].primaryEmailAddress,
      //    surveyBookingId:"Booking-4006ADAN",
      // modifiedByUserEmail:"Akhil.Singh@acache.co.in" ,
    };

    try {
      const response = await http.put(CANCEL_SURVEY_BOOKING, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      let toastShown = false;
       getMyBookings();
      if (response.status === 200 && !toastShown) {
         setTimeout(() => {
          setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Survey was cancelled successfully",
        });
        toastShown = true;
        }, 2000);
        
        
      } else if (!toastShown) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again",
        });
        toastShown = true;
      }

     
    } catch (error) {
      console.error("Cancel API error:", error);
    }
  }

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  return (
    <div className="" style={{ backgroundColor: "#f4f5f7", textAlign: "left" }}>
      <Header></Header>
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />

      <div className={isMobile ? "my-5 px-3" : "my-5 px-5"} style={{ textAlign: "left" }}>
        <h5 className="fw-bold1">
          {activeTab === "My Bookings" ? "My Bookings" : "New Booking"}
        </h5>
        <p className="text-muted">
          {activeTab === "My Bookings"
            ? "View or edit your bookings here"
            : "Fill in the details to create a new booking"}
        </p>
      </div>

      {/* Tabs */}
      <div className={isMobile ? "d-flex mb-4 px-3" : "d-flex mb-4 px-5"}>
        <button
          className={
            activeTab === "New Booking"
              ? "btn btn-danger flex-fill py-3 fw-semibold"
              : "btn btn-light flex-fill py-3 fw-semibold"
          }
          onClick={() => {
            setActiveTab("New Booking");
            getMyBookings();
            setWantToUpdate(false);
          }}
        >
          New Booking
        </button>
        <button
          className={
            activeTab === "My Bookings"
              ? "btn btn-danger flex-fill py-3 fw-semibold"
              : "btn btn-light flex-fill py-3 fw-semibold"
          }
          onClick={() => {
            setActiveTab("My Bookings");
            getMyBookings();
            setWantToUpdate(false);
          }}
        >
          My Bookings
        </button>
      </div>
         {activeTab === "New Booking" &&
      myBookingList.length > 0 && !wantToUpdate && !isLoading
       ? (
        <p className="d-flex justify-content-center mt-5 px-5">
          You already have active bookings. Please visit the My Bookings tab to manage.
        </p>
      ) : null}
      {(activeTab === "New Booking" && !isLoading ) &&
        (myBookingList.length === 0 || wantToUpdate) && (
          <div className={isMobile ? "row px-3" : "row px-5"}>
            <form className="grid gap-4 mt-8 mb-5 ">
              <h5 className="mb-4 fw-bold">Personal Information</h5>
              <div className="">
                <div className="card shadow p-4 mb-5">
                  <div className="row g-4">
                    {/* First Name */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="floatingName"
                        className="form-label fw-bold"
                      >
                        First Name<span className="text-danger">*</span>
                      </label>
                      <input
                        // className="form-control"
                        id="floatingName"
                        ref={firstNameRef}
                        type="text"
                        placeholder="Enter first Name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />

                      {errors.firstName && (
                        <span className={styles.formError}>
                          {errors.firstName}
                        </span>
                      )}
                    </div>

                    {/* Middle Name */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        className="form-label fw-bold"
                        htmlFor="floatingMiddle"
                      >
                        Middle Name
                      </label>
                      <input
                        type="text"
                        name="middleName"
                        className="form-control"
                        placeholder="Enter middle name"
                        id="floatingMiddle"
                        value={formData.middleName}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Last Name */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="floatingLast"
                        className="form-label fw-bold"
                      >
                        Last Name<span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        ref={lastNameRef}
                        id="floatingLast"
                        type="text"
                        name="lastName"
                        placeholder="Enter last name"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />

                      {errors.lastName && (
                        <span className={styles.formError}>
                          {errors.lastName}
                        </span>
                      )}
                    </div>

                    {/* Mobile Number */}
                    <div className="col-6 col-md-6 form-group">
                        <div className="form-group react-tel-input"></div>
                      <label
                        className="form-label fw-bold"
                        htmlFor="countryPhone"
                      >
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                  
                      <PhoneInput
                        country={formData.mobileCountryCode}
                        value={formData.mobileNumber}
                        onChange={(phone, data) => {
                          if (!phone.startsWith("+")) phone = "+" + phone;
                          setFormData({
                            ...formData,
                            mobileNumber: phone,
                            mobileCountryCode:
                              data.countryCode || formData.mobileCountryCode,
                          });
                        }}
                        inputProps={{
                          name: "mobileNumber",
                          required: true,
                          id: "countryPhone",
                          ref: mobileRef, 
                          className: "form-control react-tel-input",
                        }}
                        containerClass="w-100"
                        inputClass="w-100 react-tel-input"
                        enableSearch
                      />
                      {errors.mobileNumber && (
                        <span className={styles.formError}>
                          {errors.mobileNumber}
                        </span>
                      )}
                    </div>
                    {/* Landline Number */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="landlineNumber"
                        className="form-label fw-bold"
                      >
                        Alternate Phone Number
                      </label>
                      <input
                        id="landlineNumber"
                        className="form-control"
                        pattern="^(?:0|\+44|0044)?(?:1\d{9}|2\d{9})$"
                        title="Enter a valid UK landline number"
                        placeholder="Enter alternate phone number"
                        type="text"
                        name="landlineNumber"
                        value={formData.landlineNumber}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Primary Email */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="floatingEmail"
                        className="form-label fw-bold"
                      >
                        Email Address<span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                       ref={emailRef}
                        id="floatingEmail"
                        type="email"
                        name="primaryEmail"
                        placeholder="Enter email address"
                        value={formData.primaryEmail}
                        onChange={handleChange}
                        disabled={wantToUpdate}
                        required
                      />

                      {errors.primaryEmail && (
                        <span className={styles.formError}>
                          {errors.primaryEmail}
                        </span>
                      )}
                    </div>

                    {/* Alternate Email */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="floatingAlternate"
                        className="form-label fw-bold"
                      >
                        Alternate Email Address
                      </label>
                      <input
                        className="form-control"
                        id="floatingAlternate"
                        type="email"
                        name="alternateEmail"
                        placeholder="Enter alternate email address"
                        value={formData.alternateEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                {/* Add property fields here */}
              </div>
              <h5 className="fw-bold mt-4 mb-4">Property Information</h5>
              <div className="mt-4">
                <div className="card shadow p-4 mb-5">
                  <div className="row g-4">
                    {/* site Name */}
                    <div className="col-md-6 form-group">
                      <label
                        htmlFor="buildingName"
                        className="form-label fw-bold"
                      >
                        Site Name<span className="text-danger">*</span>
                      </label>
                      <input
                        id="buildingName"
                         ref={propertyNameRef}
                        className="form-control"
                        // disabled={wantToUpdate}
                        disabled
                        placeholder="Enter Site name"
                        type="text"
                        name="buildingName"
                        value={formData.buildingName}
                        onChange={handleChange}
                      />

                      {errors.buildingName && (
                        <span className={styles.formError}>
                          {errors.buildingName}
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 form-group">
                      <label
                        htmlFor="blockName"
                        className="form-label fw-bold"
                      >
                        Building Name<span className="text-danger">*</span>
                      </label>
                      <input
                        id="blockName"
                         ref={blockNameRef}
                        className="form-control"
                        // disabled={wantToUpdate}
                        disabled
                        placeholder="Enter Building name"
                        type="text"
                        name="blockName"
                        value={formData.blockName}
                        onChange={handleChange}
                      />

                      {errors.blockName && (
                        <span className={styles.formError}>
                          {errors.blockName}
                        </span>
                      )}
                    </div>

                    {/* Property Address */}
                    <div className="col-md-6 form-group">
                      <label
                        htmlFor="propertyAddress"
                        className="form-label fw-bold"
                      >
                        Site Address<span className="text-danger">*</span>
                      </label>
                      <input
                        id="propertyAddress"
                        ref={propertyAddressRef}
                        className="form-control"
                        disabled
                        placeholder="Enter site address"
                        type="text"
                        name="propertyAddress"
                        value={formData.propertyAddress}
                        onChange={handleChange}
                      />

                      {errors.propertyAddress && (
                        <span className={styles.formError}>
                          {errors.propertyAddress}
                        </span>
                      )}
                    </div>
                    {/* Secondary Address */}
                    <div className="col-md-6 form-group">
                      <label htmlFor="address" className="form-label fw-bold">
                        Secondary Address
                      </label>
                      <input
                        id="address"
                        placeholder="Enter secondary address"
                        className="form-control"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Apartment Number */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="apartmentNumber"
                        className="form-label fw-bold"
                      >
                        {isMobile ? "Apt/Flat/House No." :"Apartment / Flat / House Number"}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        id="apartmentNumber"
                        className="form-control"
                          ref={apartmentRef}
                        disabled
                        placeholder="Enter apartment/flat/house no."
                        type="text"
                        name="apartmentNumber"
                        value={formData.apartmentNumber}
                        onChange={handleChange}
                      />

                      {errors.apartmentNumber && (
                        <span className={styles.formError}>
                          {errors.apartmentNumber}
                        </span>
                      )}
                    </div>

                    {/* City Name */}
                    <div className="col-6 col-md-6 form-group">
                      <label htmlFor="cityName" className="form-label fw-bold">
                        City<span className="text-danger">*</span>
                      </label>
                      <input
                        id="cityName"
                        className="form-control"
                          ref={cityRef}
                        disabled
                        placeholder="Enter city"
                        type="text"
                        name="cityName"
                        value={formData.cityName}
                        onChange={handleChange}
                      />

                      {errors.cityName && (
                        <span className={styles.formError}>
                          {errors.cityName}
                        </span>
                      )}
                    </div>

                    {/* Post Code */}
                    <div className="col-6 col-md-6 form-group">
                      <label htmlFor="postCode" className="form-label fw-bold">
                        Post Code<span className="text-danger">*</span>
                      </label>
                      <input
                        id="postCode"
                        ref={postCodeRef}
                        className="form-control"
                        disabled
                        placeholder="Enter post code"
                        type="text"
                        name="postCode"
                        value={formData.postCode}
                        onChange={handleChange}
                        onBlur={(e) => fetchPostCodeInfo(e.target.value)}
                      />

                      {errors.postCode && (
                        <span className={styles.formError}>
                          {errors.postCode}
                        </span>
                      )}
                    </div>

                    {/* Post Code Info */}
                    {/* <div className="col-md-6">
                  <label htmlFor="postcodeInfo" className="form-label fw-bold">
                    Post Code Address
                  </label>
                  <input
                    id="postcodeInfo"
                    className="form-control"
                    placeholder="Post Code Address"
                    type="text"
                    name="postcodeInfo"
                    value={formData.postCodeInfo}
                    disabled
                  />

                </div> */}

                    {/* Number of Doors */}
                    <div className="col-6 col-md-6 form-group">
                      <label
                        htmlFor="numberOfDoors"
                        className="form-label fw-bold"
                      >
                        Number of Doors<span className="text-danger">*</span>
                      </label>
                      <input
                        id="numberOfDoors"
                          ref={doorsRef}
                        className="form-control"
                        placeholder="Enter number of doors"
                        type="number"
                        name="numberOfDoors"
                        min={0}
                        value={formData.numberOfDoors}
                        onChange={(e) => {
                            const value = Number(e.target.value);
                            if (value <= 10) {
                              handleChange(e);
                            }
                          }}

                      />

                      {errors.numberOfDoors && (
                        <span className={styles.formError}>
                          {errors.numberOfDoors}
                        </span>
                      )}
                    </div>

                    <div className="col-12 form-group">
                      <label
                        htmlFor="specialRequest"
                        className="form-label fw-bold"
                      >
                        Additional Comments
                      </label>
                      <textarea
                        id="specialRequest"
                        placeholder="Additional Comments"
                        className="form-control"
                        name="specialRequest"
                        value={formData.specialRequest}
                        onChange={handleChange}
                        rows={4}
                      />
                    </div>

                    {/* Additional Comments */}
                  </div>
                </div>
              </div>
              <h5 className="fw-bold mt-4 mb-4">Schedule Appointment</h5>
              <div className="mt-4">
                <div className="card shadow p-4 mb-5">
                  <div className="row g-4">
                    {/* Building Name */}
                    <div className="col-md-6">
                      <div className="calendar">
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="en-gb"
                          ref={calendarRef}
                        >
                          <DateCalendar
                            value={formData.appointmentDate}
                            onChange={handleDateChange}
                            minDate={
                              userScheduleDTO
                                ? dayjs(userScheduleDTO.startDate).tz("Europe/London")
                                : undefined
                            }
                            maxDate={
                              userScheduleDTO
                                ? dayjs(userScheduleDTO.endDate).tz("Europe/London")
                                : undefined
                            }
                            shouldDisableDate={(day) => {
                              const d = dayjs(day);
                              if (d.isBefore(dayjs(), "day")) return true;
                              // Disable weekends (Saturday and Sunday)
                              if ([0, 6].includes(d.day())) return true;
                              return false;
                            }}
                          />
                        </LocalizationProvider>
                        {errors.appointmentDate && (
                          <span className={styles.formError}>
                            {errors.appointmentDate}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="timeSection">
                        <label className="label mb-3">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="var(--primary-color)"
                          >
                            <path d="M12 8V12l3 3" />
                            <path d="M12 4a8 8 0 100 16 8 8 0 000-16z" />
                          </svg>
                          <span> Pick a time</span>
                        </label>
                      <div ref={timeRef}>
                        <div className="timeGrid">
                          {(showNoAvailableSlotsMessage ||
                            (!userScheduleDTO &&
                              formData.appointmentDate &&
                              [0, 6].includes(
                                formData.appointmentDate.day()
                              ))) && (
                            <p className={styles.noSlotsMessage}>
                              No slots found for the selected date. Please
                              select another date.
                            </p>
                          )}
                          {availableSlots
                            .filter((slot) => {
                              const nowLondon = dayjs().tz("Europe/London");
                              const slotTimeLondon = dayjs.tz(
                                slot.formattedDateTime,
                                "Europe/London"
                              );
                              return slotTimeLondon.isAfter(nowLondon);
                            })
                            .map((slot, index) => {
                              if (
                                !userScheduleDTO &&
                                formData.appointmentDate &&
                                [0, 6].includes(formData.appointmentDate.day())
                              ) {
                                return null;
                              }
                              const isSelected =
                                formData.appointmentDate &&
                                dayjs(slot.formattedDateTime)
                                  .tz("Europe/London")
                                  .isSame(
                                    formData.appointmentDate.format(
                                      "YYYY-MM-DDTHH:mm"
                                    )
                                  );
                              return (
                                <button
                                  type="button"
                                  key={index}
                                  className={`timeButton ${
                                    isSelected ? "selected" : ""
                                  }`}
                                  onClick={() =>
                                    handleTimeSelectupdate(
                                      dayjs.tz(
                                        slot.formattedDateTime,
                                        "Europe/London"
                                      )
                                    )
                                  }
                                >
                                  {dayjs
                                    .tz(slot.formattedDateTime, "Europe/London")
                                    .format("hh:mm A")}
                                </button>
                              );
                            })}
                        </div>
                      </div>
                        {errors.appointmentTime && (
                          <span className={styles.formError}>
                            {errors.appointmentTime}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Row className="d-flex justify-content-end gap-3">
                 <Col md={2} xs={12}>
                  <button
                    type="reset"
                    className="btn-tertiary"
                    // size="lg"
                    // variant="secondary"
                     onClick={() => setActiveTab("My Bookings")}
                    //onClick={() => setShowCancelModal(true)}
                    // onClick={() => {  setShowConfirmation(true) }}
                    style={{ width: "100%",height: '47.5px' }}
                  >
                    Cancel
                  </button>
                </Col>
                <Col md={2} xs={12}>
                  <button
                    type="reset"
                    className="btn-secondary"
                    // size="lg"
                    // variant="secondary"
                     onClick={resetform}
                    //onClick={() => setShowCancelModal(true)}
                    // onClick={() => {  setShowConfirmation(true) }}
                    style={{ width: "100%" }}
                  >
                    Reset
                  </button>
                </Col>
                <Col md={2} xs={12}>
                  <button
                    // variant="primary"
                    // size="lg"
                    className="btn-primary"
                    // active
                    type="submit"
                    style={{ width: "100%" }}
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </Col>
              </Row>
            </form>
          </div>
        )}
   
      {showConfirmation && (
        <div className="service-card">
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent + " booking-card mx-auto"}>
              {/* Inner wrapper */}
              <div className="booking-container1">
                {/* Circle Tick Icon */}
                <div className="booking-icon">
                  <i className="fa fa-solid fa-check text-success"></i>
                </div>

                {/* Title */}
                <h3 className="booking-title">Booking Confirmed!</h3>

                {/* Message */}
                <p className="booking-message">
                  You will shortly receive an email
                  <br />
                  confirmation with your booking details.
                </p>

                {/* Booking Date */}
                <div className="booking-info" style={{lineHeight:'1'}}>
                  <h4>Booking Date & Time</h4>
                  <p>
                    {formData.appointmentDate
                      ? formData.appointmentDate.format(
                          "DD MMM YYYY, dddd, HH:mm"
                        )
                      : "None"}
                  </p>
                </div>

                {/* Property Address */}
                <div className="booking-info" style={{lineHeight:'1.3'}}>
                  <h4>Property Address</h4>
                  <p>
                    {formData?.apartmentNumber}, {formData?.buildingName},{" "}
                    {formData?.propertyAddress}
                    <br />
                    {formData?.cityName}, {formData?.postCode}
                    <br />
                  </p>
                </div>

                {/* Button */}
                <button
                  type="button"
                  className="booking-btn mt-3"
                  onClick={() => {
                    setActiveTab("My Bookings");
                    setShowConfirmation(false);
                    getMyBookings();
                  }}
                >
                  View Booking Details
                </button>
              </div>
              {/* end .booking-container */}
            </div>
          </div>
        </div>
      )}
      {alreadyBookByAnother && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h5>Booking Already Exists!</h5>
            <p>
              This building has already been booked for inspection by another
              user.
            </p>
            <Button
              type="reset"
              className="mr15 mb15"
              size="lg"
              variant="secondary"
              onClick={() => setAlreadyBookByAnother(false)}
            >
              Close
            </Button>
          </div>
        </div>
      )}
      {alreadyBookBySameUser && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h5>Booking Already Exists!</h5>
            <p>
              You’ve already booked this building for inspection. <br></br>
              Do you want to make changes to your booking?
            </p>
            <Button
              type="button"
              className="mr15 mb15"
              size="lg"
              variant="primary"
              onClick={() => bindBookingData()}
            >
              Yes
            </Button>
            <Button
              type="reset"
              className="mr15 mb15"
              size="lg"
              variant="secondary"
              onClick={() => setAlreadyBookBySameUser(false)}
            >
              No
            </Button>
          </div>
        </div>
      )}
      {showCancelModal && (
        <div className="cancel-modal-overlay">
          <div className="cancel-modal-content">
            <i
              className="fa-solid fa-xmark fa-sm close-icon"
              style={{ cursor: "pointer" }}
              onClick={() => setShowCancelModal(false)}
            ></i>

            <h2 className="cancel-modal-title m-5">
              Do you want to cancel <br /> your booking?
            </h2>

            <div className="cancel-modal-actions">
              <Button
                variant=""
                type="reset"
                className="cancel-btn-go-back-go"
                size="sm"
                onClick={() => setShowCancelModal(false)}
              >
                Go back
              </Button>
              <Button
                variant=""
                type="button"
                className="cancel-btn-cancel"
                size="sm"
                onClick={() => {
                  cancelBooking();
                  setShowCancelModal(false);
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}

      {activeTab === "My Bookings" && (
        <>
        {myBookingList.length > 0 && (
            <div className={isMobile ? "px-3" : "px-5"}>
              {/* ---------------- Desktop View ---------------- */}
              <h5 className="fw-bold1 mt-5">Upcoming Bookings</h5>
              <div className="card shadow-sm d-none d-md-block mt-3">
                <div className="row bg-light fw-bold p-3 m-0 border-bottom">
                  <div className="col-3">Property Address</div>
                  <div className="col-3">Personal Details</div>
                  <div className="col-3">Booking Date</div>
                  <div className="col-3">Status</div>
                </div>

                {myBookingList.map((booking, index) => (
                  <div
                    className="row p-3 m-0 align-items-center border-bottom"
                    key={index}
                  >
                    {/* Property Address */}
                    <div className="col-3">
                      <p className="mb-1 fw-semibold">{booking?.buildingName}</p>
                      <p className="mb-1">
                        {booking?.apartmentNumber}, {booking?.address}
                      </p>
                      <p className="mb-0">
                        {booking?.city}, {booking?.postCode}
                      </p>
                    </div>

                    {/* Personal Details */}
                    <div className="col-3">
                      <p className="mb-1 fw-semibold">
                        {booking?.firstName} {booking?.lastName}
                      </p>
                      <p className="mb-1">{booking?.primaryEmailAddress}</p>
                      <p className="mb-0">{booking?.mobileNumber}</p>
                    </div>

                    {/* Booking Date */}
                    <div className="col-3">
                      <p className="mb-1 fw-semibold">
                        {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </p>
                      <p className="mb-0">
                        {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                          weekday: "long",
                        })}
                        ,{" "}
                        {new Date(booking?.bookedDate).toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p>
                    </div>

                    {/* Status */}
                    <div className="col-3">
                      <span
                        className={`badge px-3 py-2 ${booking?.status === "Scheduled"
                            ? "bg-primary bg-opacity-25 text-primary"
                            : booking?.status === "Canceled"
                              ? "bg-warning bg-opacity-25 text-warning"
                              : "bg-danger bg-opacity-25 text-danger"
                          }`}
                      >
                        {booking?.status}
                      </span>
                    </div>
                  </div>
                ))}

              
              </div>
              {/* Outer Buttons - show only on desktop */}
              <div className="d-none d-md-flex gap-3 mt-3 justify-content-end">
                <button
                  className="btn btn-primary d-flex align-items-center gap-2 py-2"
                  onClick={() => {
                    setActiveTab("New Booking");
                    setErrors({});
                    bindBookingData();
                  }}
                >
                  <i className="fa fa-solid fa-calendar text-white"></i> Reschedule
                </button>
                <button
                  className="btn btn-dangerd-flex align-items-center gap-2 py-2"
                  onClick={() => setShowCancelModal(true)}
                >
                  <i className="fa fa-solid fa-xmark text-white"></i> Cancel
                </button>
              </div>
              
               
            
              {/* ---------------- Mobile View ---------------- */}
             
              <div className="d-md-none">
                {myBookingList.length>0 && <h6 className="">Upcoming Bookings</h6>}
                {myBookingList.map((booking, index) => (
                  
                  <div
                    className={`card booking-card mx-auto mb-3 ${expandedIndex === booking.surveyBookingId ? "expanded" : ""
                      }`}
                    key={index}
                  >
                    
                    {/* Header */}
                    <div
                      className="booking-header"
                      role="button"
                      tabIndex={0}
                      onClick={() =>
                        setExpandedIndex(expandedIndex === booking.surveyBookingId ? null : booking.surveyBookingId)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setExpandedIndex(
                            expandedIndex === booking.surveyBookingId ? null : booking.surveyBookingId
                          );
                        }
                      }}
                      style={{ cursor: "pointer", width: '85vw' }}
                    >
                      <div>
                        <h6 className="booking-name">
                          {booking?.firstName} {booking?.lastName}
                        </h6>
                        <p className="booking-date mb-1">
                          Booking Date:{" "}
                          {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                          ,{" "}
                          {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                            weekday: "long",
                          })}
                          ,{" "}
                          {new Date(booking?.bookedDate).toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                        <span
                          className={`status-pill ${booking?.status === "Scheduled"
                              ? "scheduled"
                              : booking?.status === "Completed"
                                ? "bg-success bg-opacity-25 text-success"
                                : "other"
                            }`}
                        >
                          {booking?.status}
                        </span>
                      </div>

                      <i
                        className={`fa-solid ${expandedIndex === booking.surveyBookingId
                            ? "fa-chevron-up"
                            : "fa-chevron-down"
                          } expand-icon`}
                        aria-hidden="true"
                        style={{ pointerEvents: "none", fontSize: 18 }}
                      />
                    </div>

                    {/* Expanded Details */}
                    <div
                      className="booking-details"
                      style={{
                        display: expandedIndex === booking.surveyBookingId ? "block" : "none",
                        marginTop: 10,
                        width: '85vw'
                      }}
                      aria-hidden={expandedIndex !== booking.surveyBookingId}
                    >
                      <p>
                        <strong>Address:</strong> {booking?.apartmentNumber},{" "}
                        {booking?.address}
                      </p>
                      <p>
                        <strong>Phone:</strong> {booking?.mobileNumber}
                      </p>
                      <p>
                        <strong>Email:</strong> {booking?.primaryEmailAddress}
                      </p>
                      <p>
                        <strong>Apt/Flat/House :</strong> {booking?.apartmentNumber}
                      </p>
                      <p>
                        <strong>City:</strong> {booking?.city}
                      </p>
                      <p>
                        <strong>Post Code:</strong> {booking?.postCode}
                      </p>


                      <div className="action-buttons mt-3 d-flex gap-2">
                        <button
                          className="btn btn-dark flex-fill"
                          onClick={() => {
                            setActiveTab("New Booking");
                            setErrors({});
                            bindBookingData();
                          }}
                        >
                          <i className="fa-solid fa-calendar"></i> Reschedule
                        </button>
                        <button
                          className="btn btn-danger flex-fill"
                          onClick={() => setShowCancelModal(true)}
                        >
                          <i className="fa-solid fa-times"></i> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                ))}

            {/* {myPastBookingList.length>0 && <h6 className="">Past Bookings</h6>}
                 {myPastBookingList.map((booking, index) => (
                  <div
                    className={`card booking-card mx-auto mb-3 ${expandedIndex === booking.surveyBookingId ? "expanded" : ""
                      }`}
                    key={index}
                  >

                    <div
                      className="booking-header"
                      role="button"
                      tabIndex={0}
                      onClick={() =>
                        setExpandedIndex(expandedIndex === booking.surveyBookingId ? null : booking.surveyBookingId)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setExpandedIndex(
                            expandedIndex === booking.surveyBookingId ? null : booking.surveyBookingId
                          );
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        <h6 className="booking-name">
                          {booking?.firstName} {booking?.lastName}
                        </h6>
                        <p className="booking-date mb-1">
                          Booking Date:{" "}
                          {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                          ,{" "}
                          {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                            weekday: "long",
                          })}
                          ,{" "}
                          {new Date(booking?.bookedDate).toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                        <span
                          className={`status-pill ${booking?.status === "Scheduled"
                              ? "scheduled"
                              : booking?.status === "Completed"
                                ? "bg-success bg-opacity-25 text-success"
                                : "other"
                            }`}
                        >
                          {booking?.status}
                        </span>
                      </div>

                      <i
                        className={`fa ${expandedIndex === booking.surveyBookingId
                            ? "fa-chevron-up"
                            : "fa-chevron-down"
                          } expand-icon`}
                        aria-hidden="true"
                        style={{ pointerEvents: "none", fontSize: 18 }}
                      />
                    </div>

                   
                    <div
                      className="booking-details"
                      style={{
                        display: expandedIndex === booking.surveyBookingId ? "block" : "none",
                        marginTop: 10,
                      }}
                      aria-hidden={expandedIndex !== booking.surveyBookingId}
                    >
                      
                      <p>
                        <strong>Address:</strong> {booking?.apartmentNumber},{" "}
                        {booking?.address}
                      </p>
                      <p>
                        <strong>Phone:</strong> {booking?.mobileNumber}
                      </p>
                      <p>
                        <strong>Email:</strong> {booking?.primaryEmailAddress}
                      </p>
                      <p>
                        <strong>Apt/Flat/House :</strong> {booking?.apartmentNumber}
                      </p>
                      <p>
                        <strong>City:</strong> {booking?.city}
                      </p>
                      <p>
                        <strong>Post Code:</strong> {booking?.postCode}
                      </p>


                    </div>
                  </div>
                ))}
 */}


              </div>
            </div>
            
          )}
           {/* ---------------- Desktop View past booking---------------- */}
          {myPastBookingList.length > 0 && (
            <div className={isMobile ? "px-3" : "px-5"}>

              <h5 className="fw-bold1 mt-5">Past Bookings</h5>
              <div className="card shadow-sm d-none d-md-block mt-3">
                <div className="row bg-light fw-bold p-3 m-0 border-bottom">
                  <div className="col-3">Property Address</div>
                  <div className="col-3">Personal Details</div>
                  <div className="col-3">Booking Date</div>
                  <div className="col-3">Status</div>
                </div>



                {myPastBookingList.map((booking, index) => (
                  <div
                    className="row p-3 m-0 align-items-center border-bottom"
                    key={index}
                  >
                    {/* Property Address */}
                    <div className="col-3">
                      <p className="mb-1 fw-semibold">{booking?.buildingName}</p>
                      <p className="mb-1">
                        {booking?.apartmentNumber}, {booking?.address}
                      </p>
                      <p className="mb-0">
                        {booking?.city}, {booking?.postCode}
                      </p>
                    </div>

                    {/* Personal Details */}
                    <div className="col-3">
                      <p className="mb-1 fw-semibold">
                        {booking?.firstName} {booking?.lastName}
                      </p>
                      <p className="mb-1">{booking?.primaryEmailAddress}</p>
                      <p className="mb-0">{booking?.mobileNumber}</p>
                    </div>

                    {/* Booking Date */}
                    <div className="col-3">
                      <p className="mb-1 fw-semibold">
                        {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </p>
                      <p className="mb-0">
                        {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                          weekday: "long",
                        })}
                        ,{" "}
                        {new Date(booking?.bookedDate).toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p>
                    </div>

                    {/* Status */}
                    <div className="col-3">
                      <span
                        className={`badge px-3 py-2 ${booking?.status === "Scheduled"
                          ? "bg-primary bg-opacity-25 text-primary"
                          : booking?.status === "Completed"
                            ? "bg-success bg-opacity-25 text-success"
                            : "bg-danger bg-opacity-25 text-danger"
                          }`}
                      >
                        {booking?.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
               <div className="d-md-none">

            {myPastBookingList.length>0 && <h6 className="">Past Bookings</h6>}
                 {myPastBookingList.map((booking, index) => (
                  <div
                    className={`card booking-card mx-auto mb-3 ${expandedIndex === booking.surveyBookingId ? "expanded" : ""
                      }`}
                    key={index}
                  >
                    {/* Header */}
                    <div
                      className="booking-header"
                      role="button"
                      tabIndex={0}
                      onClick={() =>
                        setExpandedIndex(expandedIndex === booking.surveyBookingId ? null : booking.surveyBookingId)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setExpandedIndex(
                            expandedIndex === booking.surveyBookingId ? null : booking.surveyBookingId
                          );
                        }
                      }}
                      style={{ cursor: "pointer", width: '85vw' }}
                    >
                      <div>
                        <h6 className="booking-name">
                          {booking?.firstName} {booking?.lastName}
                        </h6>
                        <p className="booking-date mb-1">
                          Booking Date:{" "}
                          {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                          ,{" "}
                          {new Date(booking?.bookedDate).toLocaleDateString("en-GB", {
                            weekday: "long",
                          })}
                          ,{" "}
                          {new Date(booking?.bookedDate).toLocaleTimeString("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                        <span
                          className={`status-pill ${booking?.status === "Scheduled"
                              ? "scheduled"
                              : booking?.status === "Completed"
                                ? "bg-success bg-opacity-25 text-success"
                                : "other"
                            }`}
                        >
                          {booking?.status}
                        </span>
                      </div>

                      <i
                        className={`fa-solid ${expandedIndex === booking.surveyBookingId
                            ? "fa-chevron-up"
                            : "fa-chevron-down"
                          } expand-icon`}
                        aria-hidden="true"
                        style={{ pointerEvents: "none", fontSize: 18 }}
                      />
                    </div>

                    {/* Expanded Details */}
                   
                    <div
                      className="booking-details"
                      style={{
                        display: expandedIndex === booking.surveyBookingId ? "block" : "none",
                        marginTop: 10,
                        width: '85vw'
                      }}
                      aria-hidden={expandedIndex !== booking.surveyBookingId}
                    >
                      
                      <p>
                        <strong>Address:</strong> {booking?.apartmentNumber},{" "}
                        {booking?.address}
                      </p>
                      <p>
                        <strong>Phone:</strong> {booking?.mobileNumber}
                      </p>
                      <p>
                        <strong>Email:</strong> {booking?.primaryEmailAddress}
                      </p>
                      <p>
                        <strong>Apt/Flat/House :</strong> {booking?.apartmentNumber}
                      </p>
                      <p>
                        <strong>City:</strong> {booking?.city}
                      </p>
                      <p>
                        <strong>Post Code:</strong> {booking?.postCode}
                      </p>


                    </div>
                  </div>
                ))}



              </div>
            </div>)}
          {(myBookingList.length === 0 && myPastBookingList.length === 0) && (
            <div className="d-flex justify-content-center mt-5">
              No bookings found
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BookingForm;
